import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead, SITE_URL } from "@/components/SEO";
import { buildFaqJsonLd } from "@/components/FAQSection";
import { FAQS } from "@/data/faqs";

export const Route = createFileRoute("/brands-resellers")({
  head: () =>
    buildHead({
      path: "/brands-resellers",
      jsonLd: buildFaqJsonLd(FAQS["/brands-resellers"].items),
      breadcrumbs: [
        { name: "Home", url: SITE_URL },
        { name: "Brands & Resellers", url: `${SITE_URL}/brands-resellers` },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/BrandsResellers")),
});
